export default "__VITE_ASSET__DXks2Itz__"